import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import debounce from 'lodash/debounce';

import { VSlider, Icon } from 'shared/components';

import theme from './SoundLevel.scss';

const propTypes = {
  outputSoundLevel: PropTypes.number.isRequired,
  setSoundLevel: PropTypes.func.isRequired,
  prevOutputSoundLevel: PropTypes.number,
  setPrevSoundLevel: PropTypes.func.isRequired,
};

const defaultProps = {
  prevOutputSoundLevel: null,
};

function viewDefiner(value) {
  if (value === 0) {
    return {
      classNameDragPlace: theme.dragPlaceMuted,
      classNameValueContainer: theme.valueContainerMuted,
      label: <FormattedMessage
        id="const.muted"
        defaultMessage="** Muted"
      />,
      icon: <Icon name="speaker-mute" />,
      classNameIcon: theme.mutedIcon,
    };
  }

  return {
    classNameDragPlace: '',
    classNameValueContainer: '',
    label: value,
    icon: <Icon name="speaker" />,
    classNameIcon: '',
  };
}

const SoundLevel = ({
  outputSoundLevel,
  setSoundLevel,
  prevOutputSoundLevel,
  setPrevSoundLevel,
}) => (
  <div className={ theme.root }>
    <div className={ theme.sign }>
      <FormattedMessage id="const.volume" defaultMessage="** Volume" />
    </div>
    <VSlider
      className={ theme.slider }
      viewDefiner={ viewDefiner }
      value={ outputSoundLevel }
      oldValue={ prevOutputSoundLevel }
      setOldValue={ debounce(setPrevSoundLevel, 500) }
      onChange={ debounce(setSoundLevel, 500) }
    />
  </div>
);

SoundLevel.propTypes = propTypes;
SoundLevel.defaultProps = defaultProps;

export default SoundLevel;
